export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fABc4AMP6lbBP.fda33184.woff2";